import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Auth/Login';
import Main from './pages/Main/Main';
import NoAccess from './pages/Auth/NoAccess';
import YandexCallback from './pages/Auth/YandexCallback';
import GoogleCallback from './pages/Auth/GoogleCallback';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

// ProtectedRoute:
//  1) Нет токена → /login
//  2) Есть токен, но нет доступа к админке (hasAdminAccess=false) → /no-access
//  3) Доступ есть → дети рендерятся
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, hasAdminAccess, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#00d4ff',
      }}>
        Загрузка...
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasAdminAccess)  return <Navigate to="/no-access" replace />;
  return children;
};

function App() {
  return (
    // ErrorBoundary — внешний слой. Ловит любой uncaught throw в дереве
    // React-компонентов и показывает дружелюбную fallback-страницу
    // вместо белого экрана.
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Публичные роуты */}
            <Route path="/login" element={<Login />} />
            <Route path="/no-access" element={<NoAccess />} />
            {/* OAuth callback'и (Yandex/Google редиректят сюда после авторизации). */}
            <Route path="/auth/yandex/callback" element={<YandexCallback />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />

            {/* Защищенные маршруты */}
            <Route
              path="/main/*"
              element={
                <ProtectedRoute>
                  <Main />
                </ProtectedRoute>
              }
            />

            {/* Корень и неизвестные роуты */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
